import { Layout } from 'antd'
import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import Header from './Header'

const MainLayout: FunctionComponent = ({ children }) => {
  const intl = useIntl()
  return (
    <Layout className="layout">
      <Header />
      <Layout.Content
        style={{
          padding: '0 50px',
          paddingBottom: '10px',
          backgroundColor: '#f9f9f9',
        }}
      >
        <div className="container">
          <div className="outer">
            <div className="inner">
              <div className="centered">
                <div className="content">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </Layout.Content>
      <Layout.Footer className="footer-wapper">
        <div className="footer">
          {intl.locale === 'en' ? (
            <span>
              <span className="footer-contents" style={{ paddingLeft: 0 }}>
                <a
                  href={
                    require('../img/file/TERMSANDCONDITIONS_en.docx').default
                  }
                  download
                >
                  Terms and Conditions
                </a>
              </span>
              <span className="footer-contents">
                <a
                  href={require('../img/file/PRIVACYPOLICY_en.docx').default}
                  download
                >
                  Privacy statement
                </a>
              </span>
            </span>
          ) : (
            <span>
              <span className="footer-contents" style={{ paddingLeft: 0 }}>
                <a
                  href={
                    require('../img/file/TERMSANDCONDITIONS_ko.docx').default
                  }
                  download
                >
                  Terms and Conditions
                </a>
              </span>
              <span className="footer-contents">
                <a
                  href={require('../img/file/PRIVACYPOLICY_ko.docx').default}
                  download
                >
                  Privacy statement
                </a>
              </span>
            </span>
          )}
          <span className="footer-contents">
            <Link to="/faq">FAQ</Link>
          </span>
          <span className="footer-contents">
            <a href="mailto:mojitok@platfarm.net">Contact</a>
          </span>
          <span className="footer-copyright">
            <b>Copyright</b> © {new Date().getFullYear()} Platfarm Inc. All
            rights reserved.
          </span>
        </div>
      </Layout.Footer>
    </Layout>
  )
}

export default MainLayout
